import { DepartmentControllerApi } from "../services";
import { getConfigObject, useMutationWithLoading } from "../utils/utils";

/**
 *
 * @author rajkumar rathod
 */
export const useStatusDepartMent = () =>
  useMutationWithLoading(
    async (param: { depId: string; status: boolean; xTENANTID?: string }) =>
      new DepartmentControllerApi(getConfigObject()).updateDepartmentStatus(
        param.depId,
        param.status,
        param.xTENANTID //xTENANTID
      )
  );
